import request from '@/utils/http';
import { SRM } from '../../constant/constant.js';

// 管理端流程信息分页列表
export const getMipAudit = (params) => {
    return request({
        url: `${SRM}/queryMipAuditBySupplierCode`,
        method: 'get',
        params
        // headers: {
        //     'Content-Type': 'application/json'
        // }
    });
};

// 管理端流程信息 删除
export const deleteMipAudit = (params) => {
    return request({
        url: `${SRM}/deleteDfaftMip`,
        method: 'delete',
        data: params
    });
};